import { useEffect, useMemo, useState } from "react"
import { AutoComplete, Spin } from "antd"
import debounce from "lodash.debounce"
import apiClient from "../../Utils/apiClient"

const AutoCompleteBox = ({
  name,
  endPoint,
  style,
  className,
  placeholder,
  onSelect,
  onChange,
  optionLabel,
  optionValue,
  label,
  options: externalOptions = [],
}) => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)
  const [inputLabel, setInputLabel] = useState(label || "")

  // const fetchOptions = async (text) => {
  //   if (!text) return
  //   setLoading(true)
  //   try {
  //     const payload =
  //       endPoint === "devices/identifiers" ? { search: text } : { [name]: text }

  //     const data = await apiClient(`filter/${endPoint}`, "POST", payload)
  //     if (data.success) {
  //       const uniqueSet = new Set()
  //       const formatted = []

  //       data.result.forEach((item) => {
  //         const id = item._id
  //         const labelText = item[name]
  //         if (id && labelText && !uniqueSet.has(id)) {
  //           uniqueSet.add(id)
  //           formatted.push({ value: id, label: labelText })
  //         }
  //       })

  //       setOptions(formatted)
  //     }
  //   } catch (error) {
  //     console.error("Autocomplete fetch error:", error)
  //     setOptions([])
  //   } finally {
  //     setLoading(false)
  //   }
  // }

  const fetchOptions = async (text) => {
    if (!text) return
    setLoading(true)
    try {
      const payload =
        endPoint === "devices/identifiers" ? { search: text } : { [name]: text }

      const data = await apiClient(`filter/${endPoint}`, "POST", payload)
      if (data.success) {
        const labelSet = new Set()
        const formatted = []

        data.result.forEach((item) => {
          const value = item[optionValue] || item["_id"]
          const labelText = item[optionLabel] || item[name]
          if (value && labelText && !labelSet.has(labelText.toLowerCase())) {
            labelSet.add(labelText.toLowerCase())
            formatted.push({ value: value, label: labelText })
          }
        })

        setOptions(formatted)
      }
    } catch (error) {
      console.error("Autocomplete fetch error:", error)
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  const debounceFetcher = useMemo(
    () => debounce(fetchOptions, 300),
    [name, endPoint]
  )

  useEffect(() => () => debounceFetcher.cancel(), [debounceFetcher])
  useEffect(() => {
    setInputLabel(label || "")
  }, [label])

  const combinedOptions = useMemo(() => {
    const map = new Map()
    ;[...externalOptions, ...options].forEach((opt) => map.set(opt.value, opt))
    return [...map.values()]
  }, [externalOptions, options])

  return (
    <AutoComplete
      options={combinedOptions}
      className={className}
      onSelect={(value, option) => {
        setInputLabel(option.label)
        if (onSelect) onSelect(value, option)
      }}
      onSearch={debounceFetcher}
      onChange={(val) => {
        setInputLabel(val)
        if (onChange) onChange(val)
      }}
      style={style || { width: "100%" }}
      placeholder={placeholder}
      allowClear
      value={inputLabel}
      notFoundContent={loading ? <Spin size="small" /> : "No results"}
    />
  )
}

export default AutoCompleteBox
